import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of, catchError, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class TrackingHistoryService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    index(payload?: any): Observable<any> {
        return this.post<any>(EndPoints.trackingHistory_Index, false, null, {
            userID: payload.userID,
            formName: payload.formName,
            formID: payload.formID
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    create(payload?: any): Observable<any> {
        return this.post<any>(EndPoints.trackingHistory_Create, false, null, { editedFields: payload.editedFields }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }
}
